import axios from "axios";
import * as types from "../index";
import * as common from "../../../../../app/common/index";

export function getAccountType() {
  const url = `${common.WEB_API_URL}/v1/system/bankaccounttype`;
  const request = axios.get(url);
  return {
    type: types.FETCH_THIRD_PARTY_PAYEE_ACCOUNT_TYPE,
    payload: request
  };
}
